(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/icon/assets/javascripts/icon-load-test.js') >= 0) return;  svs.modules.push('/components/ui/icon/assets/javascripts/icon-load-test.js'); 

if (navigator.userAgent.match(/edge/i)) {
  $('html').addClass('font-icon-active');
} else if ('FontFaceOnload' in window && typeof FontFaceOnload === 'function') {
  window.FontFaceOnload('ui-icon', {
    success: function() {
      $('html').addClass('font-icon-active');
    },
    error: function() {
      $('html').addClass('font-icon-inactive');
    },
    glyphs: '\uf157\uf101\uf102\uf104' 
  });
} else {
  $('html').addClass('font-icon-inactive');
}

 })(window);